import { Component, OnInit, AfterContentInit } from '@angular/core';
import * as $ from 'jquery';
import { ActivatedRoute, Router } from '@angular/router';
import { PromosService } from 'src/app/services/promos.service';
import { Promo } from 'src/app/models/promo.model';
import { element } from 'protractor';
import { Location } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { TipoCupon } from 'src/app/models/tipocupon.model';
import { Comercio } from 'src/app/models/comercio.model';
import { Sucursal } from 'src/app/models/sucursal.model';
import { CardRelation } from 'src/app/models/cardrelation.model';
import { AfterViewInit, AfterContentChecked, ViewChild, ElementRef } from '@angular/core';
import { BranchRelation } from 'src/app/models/branchrelation.model';
import { last } from 'rxjs/operators';
import { Title, Meta } from '@angular/platform-browser';
import { ConfigKeys } from 'src/app/config/config.keys';
import { GoogleAnalyticsService } from 'mugan86-ng-google-analytics';
import { ParamsService } from 'src/app/services/params.service';
import { AppParam } from 'src/app/models/appparam.model';
import {PromoResult} from '../../models/promoresult.model';
import {ReqVisit} from '../../models/reqvisit.model';
import {ResultDTO} from '../../models/resultdto.model';
import {v4 as uuidv4} from 'uuid';
import {Subscription} from 'rxjs';
import {FilterofferService} from '../../services/filteroffer.service';
import {Campaign} from '../../models/campaign.model';
import {CampaignsService} from '../../services/campaigns.service';

declare var $: any;

@Component({
  selector: 'app-show-promo-camp',
  templateUrl: './show-promo-camp.component.html',
  styleUrls: ['./show-promo-camp.component.css']
})
export class ShowPromoCampComponent implements OnInit {

  title = 'BanCoppel';

  idPromocion: number;
  idCamp: number;
  selectedPromo: Promo = new Promo(0, 1,'', '', '', '', '', 0, '', '', 0, '', 0, '', 2, new TipoCupon(0, ''), new Comercio(0, '', '', '', '', ''), CardRelation[0], BranchRelation[0], []);

  selectedCity: string = "Elige una ciudad";
  selectedBranch: string;
  selectedBranchName: string = "Elige una sucursal";
  sucursales: Sucursal[] = [];

  selectCityDisabled: boolean = false;
  showMap: boolean = true;

  subscription: Subscription;

  @ViewChild('mapContainer') gmap: ElementRef;
  map: google.maps.Map;
  lat = 19.4284706;
  lng = -99.1276627;

  coordinates = new google.maps.LatLng(this.lat, this.lng);

  mapOptions: google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 8
  };

  marker = new google.maps.Marker({
    position: this.coordinates,
    map: this.map,
    title: 'Marker 0'
  });
  markers = [];

  // selectedIdCard: number;
  campaign: Campaign = new Campaign(-1,'', '','','','', new Date(), new Date(), '', 0 );
  lastPage: number;


  //------VARS FOR HEADER--------
  appParams: AppParam[] = [];

  paramBCWebSiteURL: string = "";
  paramBCWebSiteURLTarget: number = 2;

  paramReqCardURL: string[] = [];
  paramReqCardURLTarget: number[] = [];

  configKeys: ConfigKeys = new ConfigKeys();

  showActivePromo: boolean = true;

  //-------VARS FOR TEST recommendations--------

  // @ts-ignore
  @ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent: ElementRef<any>;

  // promosRelated: Promo[] = [];
  currentPage: number = 0;


  constructor(
    private promosService: PromosService,
    private router: Router,
    private route: ActivatedRoute,
    private _location: Location,
    private spinner: NgxSpinnerService,
    private titleService: Title, private metaService: Meta,
    public googleAnalyticsService: GoogleAnalyticsService,
    private paramsService: ParamsService,
    private filterOfferService: FilterofferService,
    private campaignService: CampaignsService,
    private meta: Meta
  ) {

    this.subscription = this.filterOfferService.getSelectedOffer().subscribe(offerId => {

      // console.log('JSON: ' + JSON.stringify(offerId));

      //-----------Set tittle---------
      this.titleService.setTitle(this.title);

      //--------FOR HEADER---------------
      this.paramsService.getAppParams().subscribe(
        (appParams: AppParam[]) => {
          this.appParams = appParams;
          this.paramsService.setAppParams(appParams);


          //-----------Set Parameter Values--------
          appParams.forEach(appParam => {

            if (appParam.cveParametro === this.configKeys.PARAM_BCOPPEL_URL) {
              this.paramBCWebSiteURL = appParam.valor;
              this.paramBCWebSiteURLTarget = appParam.target;
            }
            if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL1) {
              this.paramReqCardURL[0] = appParam.valor;
              this.paramReqCardURLTarget[0] = appParam.target;
            }
            if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL2) {
              this.paramReqCardURL[1] = appParam.valor;
              this.paramReqCardURLTarget[1] = appParam.target;
            }
            if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL3) {
              this.paramReqCardURL[2] = appParam.valor;
              this.paramReqCardURLTarget[2] = appParam.target;
            }
            if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL4) {
              this.paramReqCardURL[3] = appParam.valor;
              this.paramReqCardURLTarget[3] = appParam.target;
            }

          });


        }
      );



      this.spinner.show();
      this.idPromocion = offerId.offerId;
      // this.idPromocion = this.route.snapshot.params['idPromo'];

      // this.selectedIdCard = this.route.snapshot.params['idCard'];
      // this.lastPage = this.route.snapshot.params['page'];

      // if(this.selectedIdCard===undefined){
      //   this.selectedIdCard=1;
      // }

      if(this.lastPage===undefined){
        this.lastPage=1;
      }

      // console.log('SELECTED PROMO=' + this.idPromocion);


      this.promosService.getPromoById(this.idPromocion)
        .subscribe(
          (promo: Promo) => {

            this.selectedPromo = promo;

            this.showActivePromo = this.parseFecha(this.selectedPromo.vigenciaFin) >= new Date();

            //-------------Deindex from GOOGLE--------
            if(!this.showActivePromo){
              this.meta.updateTag({
                name: 'robots',
                content: 'noindex,nofollow'
              });
            }

            this.promosService.setPromo(promo);
            this.spinner.hide();

            this.mapInitializer();

            //--------------Call Google Analytics Event
            var tipoPromoNombre = promo.idTipoPromocion === this.configKeys.PROMO_TYPE_PROMO ? 'Promociones' : promo.idTipoPromocion === this.configKeys.PROMO_TYPE_BANNER ? 'Banners' : 'Promociones';
            var tipoPromo = promo.idTipoPromocion === this.configKeys.PROMO_TYPE_PROMO ? 'Promo ' : promo.idTipoPromocion === this.configKeys.PROMO_TYPE_BANNER ? 'Banner ' : 'Informativa ';
            this.googleAnalyticsService.eventEmitter(tipoPromoNombre, this.campaign.nombre, tipoPromo + '(' + this.campaign.nombre + '): ' + promo.comercio.nombre  + ' - '  + promo.nombre, 1);


            var tipoPromoNombreGA4 = promo.idTipoPromocion === this.configKeys.PROMO_TYPE_PROMO ? 'bancoppel_promociones' : promo.idTipoPromocion === this.configKeys.PROMO_TYPE_BANNER ? 'bancoppel_banners' : 'bancoppel_promociones';
            var tipoPromoGA4 = promo.idTipoPromocion === this.configKeys.PROMO_TYPE_PROMO ? 'Promo ' : promo.idTipoPromocion === this.configKeys.PROMO_TYPE_BANNER ? 'Banner ' : 'Informativa ';
            this.eventGA4PushInteractions(tipoPromoNombreGA4, this.campaign.nombre, tipoPromoGA4 + '(' + this.campaign.nombre + '): ' + promo.comercio.nombre  + ' - '  + promo.nombre);


            //--------------- Record VISIT for statistics
            // console.log('ADDEDD VISIT RECORD...');
            let userId = localStorage.getItem(this.configKeys.USER_ID_KEY);
            // console.log('Getting USER_ID... ' + userId);

            if(userId===null){
              userId = uuidv4();
              // console.log('Creatin USER_ID... ' + userId);
              localStorage.setItem(this.configKeys.USER_ID_KEY, userId)
            }
            let reqVisit = new ReqVisit(userId, this.idPromocion, new Date());
            this.promosService.recordVisit(reqVisit).subscribe((resultDTO: ResultDTO) => {

              // console.log('resultDTO: ' + JSON.stringify(resultDTO));
              this.promosService.setResultDTO(resultDTO);
              // console.log('ADDEDD VISIT RECORD: ' + resultDTO.code);
            });

          }
        );


      window.scrollTo(0, 0);


      /*//--------Recommendations TEST

      console.log('Request -> cardId: ' + this.selectedIdCard);
      console.log('Request -> idPromocion: ' + this.idPromocion);
      console.log('Request -> idCliente: ' + 'asasas');
      this.promosService.getRelatedPromos(this.selectedIdCard, this.idPromocion, 'asasas')
        .subscribe(
          (promos: Promo[]) => {

            console.log('promosRelated -> records: ' + promos.length);

            this.promosRelated = promos;
            this.promosService.setPromos(promos);

          }
        );*/

      this.loadJQuery();

    });

  }


  ngOnInit() {

    //-----------Set tittle---------
    this.titleService.setTitle(this.title);

    //--------FOR HEADER---------------
    this.paramsService.getAppParams().subscribe(
      (appParams: AppParam[]) => {
        this.appParams = appParams;
        this.paramsService.setAppParams(appParams);


        //-----------Set Parameter Values--------
        appParams.forEach(appParam => {

          if (appParam.cveParametro === this.configKeys.PARAM_BCOPPEL_URL) {
            this.paramBCWebSiteURL = appParam.valor;
            this.paramBCWebSiteURLTarget = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL1) {
            this.paramReqCardURL[0] = appParam.valor;
            this.paramReqCardURLTarget[0] = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL2) {
            this.paramReqCardURL[1] = appParam.valor;
            this.paramReqCardURLTarget[1] = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL3) {
            this.paramReqCardURL[2] = appParam.valor;
            this.paramReqCardURLTarget[2] = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL4) {
            this.paramReqCardURL[3] = appParam.valor;
            this.paramReqCardURLTarget[3] = appParam.target;
          }

        });


      }
    );




    /*this.metaService.addTags([
      {property: 'og:url', content: 'http://devbancoppel.maxvalue.com.mx/showPromo/9'},
      {property: 'og:type', content: 'website'},
      {property: 'og:title', content: 'Moshi Moshi Moshi Moshi'},
      {property: 'og:description', content: '2x1 en rollos, 20% OFF en bowls'},
      {property: 'og:image', content: 'http://devbancoppel.maxvalue.com.mx/bcp/MoshiMoshi.png'}
    ]);*/

    this.spinner.show();
    this.idPromocion = this.route.snapshot.params['idPromo'];

    // this.selectedIdCard = this.route.snapshot.params['idCard'];
    this.idCamp = this.route.snapshot.params['idCamp'];

    this.campaignService.getCampaign(this.idCamp.toString()).subscribe((campaign: Campaign) => {

      this.campaign = campaign;
      this.campaignService.setCampaign(campaign);

    });


    this.lastPage = this.route.snapshot.params['page'];

   /* if(this.selectedIdCard===undefined){
      this.selectedIdCard=1;
    }*/

    if(this.lastPage===undefined){
      this.lastPage=1;
    }

    // console.log('SELECTED PROMO=' + this.idPromocion);


    this.promosService.getPromoById(this.idPromocion)
      .subscribe(
        (promo: Promo) => {

          this.selectedPromo = promo;

          this.showActivePromo = this.parseFecha(this.selectedPromo.vigenciaFin) >= new Date();

          //-------------Deindex from GOOGLE--------
          if(!this.showActivePromo){
            this.meta.updateTag({
              name: 'robots',
              content: 'noindex,nofollow'
            });
          }

          this.mapInitializer();

          //--------------Call Google Analytics Event
          var tipoPromoNombre = promo.idTipoPromocion === this.configKeys.PROMO_TYPE_PROMO ? 'Promociones' : promo.idTipoPromocion === this.configKeys.PROMO_TYPE_BANNER ? 'Banners' : 'Promociones';
          var tipoPromo = promo.idTipoPromocion === this.configKeys.PROMO_TYPE_PROMO ? 'Promo ' : promo.idTipoPromocion === this.configKeys.PROMO_TYPE_BANNER ? 'Banner ' : 'Informativa ';
          this.googleAnalyticsService.eventEmitter(tipoPromoNombre, this.campaign.nombre, tipoPromo + '(' + this.campaign.nombre + '): ' + promo.comercio.nombre  + ' - '  + promo.nombre, 1);

          //--------------Call Google Analytics 4 Event
          var tipoPromoNombreGA4 = promo.idTipoPromocion === this.configKeys.PROMO_TYPE_PROMO ? 'bancoppel_promociones' : promo.idTipoPromocion === this.configKeys.PROMO_TYPE_BANNER ? 'bancoppel_banners' : 'bancoppel_promociones';
          var tipoPromoGA4 = promo.idTipoPromocion === this.configKeys.PROMO_TYPE_PROMO ? 'Promo ' : promo.idTipoPromocion === this.configKeys.PROMO_TYPE_BANNER ? 'Banner ' : 'Informativa ';
          this.eventGA4PushInteractions(tipoPromoNombreGA4, this.campaign.nombre, tipoPromoGA4 + '(' + this.campaign.nombre + '): ' + promo.comercio.nombre  + ' - '  + promo.nombre);

          //--------------- Record VISIT for statistics
          // console.log('ADDEDD VISIT RECORD...');
          let userId = localStorage.getItem(this.configKeys.USER_ID_KEY);
          // console.log('Getting USER_ID... ' + userId);

          if(userId===null){
            userId = uuidv4();
            // console.log('Creatin USER_ID... ' + userId);
            localStorage.setItem(this.configKeys.USER_ID_KEY, userId)
          }
          let reqVisit = new ReqVisit(userId, this.idPromocion, new Date());
          this.promosService.recordVisit(reqVisit).subscribe((resultDTO: ResultDTO) => {

            // console.log('resultDTO: ' + JSON.stringify(resultDTO));
            this.promosService.setResultDTO(resultDTO);
            // console.log('ADDEDD VISIT RECORD: ' + resultDTO.code);
          });

          this.spinner.hide();

        }
      );


    window.scrollTo(0, 0);


   /* //--------Recommendations TEST

    console.log('Request -> cardId: ' + this.selectedIdCard);
    console.log('Request -> idPromocion: ' + this.idPromocion);
    console.log('Request -> idCliente: ' + 'asasas');
    this.promosService.getRelatedPromos(this.selectedIdCard, this.idPromocion, 'asasas')
      .subscribe(
        (promos: Promo[]) => {

          console.log('promosRelated -> records: ' + promos.length);

          this.promosRelated = promos;
          this.promosService.setPromos(promos);

          this.spinner.hide();
        }
      );*/

    this.loadJQuery();

  }

  sharePromoFacebook(idPromo: number){

    var url = new ConfigKeys().URL_SHARE_PROMO_FACEBOOK;

    //---------Google Analytics
    this.googleAnalyticsService.eventEmitter('Social Share', 'By Facebook', this.selectedPromo.comercio.nombre + ' - '  + this.selectedPromo.nombre.substr(0,100), 1);
    //--------------Call Google Analytics 4 Event
    this.eventGA4PushInteractions('social_share', 'By_facebook', this.selectedPromo.comercio.nombre + ' - '  + this.selectedPromo.nombre.substr(0,100));


    window.open(url + idPromo, "_blank");

  }

  sharePromoTwitter(idPromo: number, comercio: string, nombrePromo: string){

    var com = comercio.replace(' ', '');

    var url = new ConfigKeys().URL_SHARE_PROMO_TWITTER +  idPromo + '&hashtags=Bancoppel,' + com + '&text=' + nombrePromo;

    //---------Google Analytics
    this.googleAnalyticsService.eventEmitter('Social Share', 'By Twitter', this.selectedPromo.comercio.nombre + ' - '  + this.selectedPromo.nombre.substr(0,100), 1);
    //--------------Call Google Analytics 4 Event
    this.eventGA4PushInteractions('social_share', 'By_twitter', this.selectedPromo.comercio.nombre + ' - '  + this.selectedPromo.nombre.substr(0,100));


    window.open(encodeURI(url), "_blank");

  }

  sharePromoWhatsapp(idPromo: number){
    var url = new ConfigKeys().URL_SHARE_PROMO_WHATSAPP + idPromo;

    //---------Google Analytics
    this.googleAnalyticsService.eventEmitter('Social Share', 'By Whatsapp', this.selectedPromo.comercio.nombre + ' - '  + this.selectedPromo.nombre.substr(0,100), 1);
    //--------------Call Google Analytics 4 Event
    this.eventGA4PushInteractions('social_share', 'By_whatsapp', this.selectedPromo.comercio.nombre + ' - '  + this.selectedPromo.nombre.substr(0,100));


    window.location.href = url;
  }


  selectBranch(event: Event) {

    //this.selectedCity = (<HTMLSelectElement>event.target).value;
    this.selectedBranch = (<HTMLSelectElement>event.target).value;

    // console.log("VALUE SELECTED: " + this.selectedCity);

    this.promosService.getBranchesByCity(this.idPromocion, this.selectedCity)
      .subscribe(
        (sucs: Sucursal[]) => {

          //------Redo Map--------

          var bounds = new google.maps.LatLngBounds();


          this.sucursales.forEach(suc => {

            //---------------START----------
            if (suc.idSucursal === Number(this.selectedBranch)) {
              //console.log('Sucursal: ' + suc.nombre);
              bounds.extend(new google.maps.LatLng(Number(suc.latitud), Number(suc.longitud)));

              //console.log('----------->SOLO UNA SUC');
              this.mapOptions = {
                center: bounds.getCenter(),
                zoom: 15
              };
              this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
              this.loadMarkersForSucs([suc]);

              return false;
            }
            //---------------END----------

          });

        }
      );

  }

  selectBranch2(event: Event) {

    //this.selectedCity = (<HTMLSelectElement>event.target).value;
    this.selectedBranch = (<HTMLDivElement>event.target).id;
    this.selectedBranchName = (<HTMLDivElement>event.target).innerText;

    //console.log("VALUE SELECTED: " + this.selectedCity);

    this.promosService.getBranchesByCity(this.idPromocion, this.selectedCity)
      .subscribe(
        (sucs: Sucursal[]) => {

          //------Redo Map--------

          var bounds = new google.maps.LatLngBounds();


          this.sucursales.forEach(suc => {

            //---------------START----------
            if (suc.idSucursal === Number(this.selectedBranch)) {
              //console.log('Sucursal: ' + suc.nombre);
              bounds.extend(new google.maps.LatLng(Number(suc.latitud), Number(suc.longitud)));

              //console.log('----------->SOLO UNA SUC');
              this.mapOptions = {
                center: bounds.getCenter(),
                zoom: 15
              };
              this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
              this.loadMarkersForSucs([suc]);

              return false;
            }
            //---------------END----------

          });

        }
      );

  }


  populateBranches(event: Event) {

    this.selectedCity = (<HTMLSelectElement>event.target).value;

    //console.log("VALUE SELECTED: " + this.selectedCity);

    this.promosService.getBranchesByCity(this.idPromocion, this.selectedCity)
      .subscribe(
        (sucs: Sucursal[]) => {
          this.sucursales = sucs;
          //------Redo Map--------

          var bounds = new google.maps.LatLngBounds();
          var contSucs = 0;

          this.sucursales.forEach(suc => {

            //console.log('Sucursal: ' + suc.nombre);
            bounds.extend(new google.maps.LatLng(Number(suc.latitud), Number(suc.longitud)));
            contSucs++;

          });

          //console.log('----------->TOTAL SUCS: ' + contSucs);

          if (contSucs === 1) {
            //console.log('----------->SOLO UNA SUC');
            this.mapOptions = {
              center: bounds.getCenter(),
              zoom: 15
            };
            this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
          }
          else {
            //console.log('----------->VARIAS SUCS');
            this.map = new google.maps.Map(this.gmap.nativeElement);
            this.map.fitBounds(bounds);
          }

          this.loadMarkersForSucs(this.sucursales);

          //---------------END----------

        }
      );

  }

  populateBranches2(event: Event) {

    this.selectedCity = (<HTMLDivElement>event.target).id;

    //console.log("VALUE SELECTED: " + this.selectedCity);

    this.promosService.getBranchesByCity(this.idPromocion, this.selectedCity)
      .subscribe(
        (sucs: Sucursal[]) => {
          this.sucursales = sucs;
          //------Redo Map--------

          var bounds = new google.maps.LatLngBounds();
          var contSucs = 0;

          this.sucursales.forEach(suc => {

            //console.log('Sucursal: ' + suc.nombre);
            bounds.extend(new google.maps.LatLng(Number(suc.latitud), Number(suc.longitud)));
            contSucs++;

          });

          //console.log('----------->TOTAL SUCS: ' + contSucs);

          if (contSucs === 1) {
            //console.log('----------->SOLO UNA SUC');
            this.mapOptions = {
              center: bounds.getCenter(),
              zoom: 15
            };
            this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
          }
          else {
            //console.log('----------->VARIAS SUCS');
            this.map = new google.maps.Map(this.gmap.nativeElement);
            this.map.fitBounds(bounds);
          }

          this.loadMarkersForSucs(this.sucursales);

          //---------------END----------

        }
      );

  }

  mapInitializer() {

    var bounds = new google.maps.LatLngBounds();
    var contSucs = 0;

    this.selectedPromo.sucursales.forEach(branchRel => {

      //console.log('Sucursal: ' + branchRel.sucursal.nombre);

      bounds.extend(new google.maps.LatLng(Number(branchRel.sucursal.latitud), Number(branchRel.sucursal.longitud)));
      contSucs++;

    });


    //console.log('----------->TOTAL SUCS: ' + contSucs);

    if(contSucs === 0){

      this.selectCityDisabled =  true;
      this.showMap = false;

      this.mapOptions = {
        center: this.coordinates,
        zoom: 7,
        disableDefaultUI: true,
        noClear: true,
        draggable: false
      };
      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
    }
    else
    if (contSucs === 1) {
      //console.log('----------->SOLO UNA SUC');
      this.mapOptions = {
        center: bounds.getCenter(),
        zoom: 15
      };
      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
    }
    else {
      //console.log('----------->VARIAS SUCS');
      this.map = new google.maps.Map(this.gmap.nativeElement);
      this.map.fitBounds(bounds);
    }

    this.loadMarkers(this.selectedPromo.sucursales);

  }

  loadMarkers(sucs: BranchRelation[]) {

    sucs.forEach(branchRel => {

      //Creating a new marker object
      //console.log('Adding MARKER ->' + branchRel.sucursal.nombre);


      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(Number(branchRel.sucursal.latitud), Number(branchRel.sucursal.longitud)),
        map: this.map
      });

      //creating a new info window with markers info
      const infoWindow = new google.maps.InfoWindow({
        content: '<center><b>' + branchRel.sucursal.nombre + '</b></center><br>' + branchRel.sucursal.calle + ', ' + branchRel.sucursal.cp + ', ' + branchRel.sucursal.ciudad
      });

      //Add click event to open info window on marker
      //marker.addListener('click', () => {
      marker.addListener('mouseover', () => {
        infoWindow.open(marker.getMap(), marker);
      });
      marker.addListener('click', () => {
        infoWindow.open(marker.getMap(), marker);
      });

      // assuming you also want to hide the infowindow when user mouses-out
      marker.addListener('mouseout', function () {
        infoWindow.close();
      });

      //Adding marker to google maps
      marker.setMap(this.map);

    });

  }


  loadMarkersForSucs(sucs: Sucursal[]) {

    sucs.forEach(sucursal => {

      //Creating a new marker object
      //console.log('Adding MARKER ->' + sucursal.nombre);


      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(Number(sucursal.latitud), Number(sucursal.longitud)),
        map: this.map
      });

      //creating a new info window with markers info
      const infoWindow = new google.maps.InfoWindow({
        content: '<center><b>' + sucursal.nombre + '</b></center><br>' + sucursal.calle + ', ' + sucursal.cp + ', ' + sucursal.ciudad
      });

      //Add click event to open info window on marker
      //marker.addListener('click', () => {
      marker.addListener('mouseover', () => {
        infoWindow.open(marker.getMap(), marker);
      });
      marker.addListener('click', () => {
        infoWindow.open(marker.getMap(), marker);
      });

      // assuming you also want to hide the infowindow when user mouses-out
      marker.addListener('mouseout', function () {
        infoWindow.close();
      });

      //Adding marker to google maps
      marker.setMap(this.map);

    });

  }



  goBack() {

    this._location.back();
  }

  goToInit(){

    // window.location.href = this.configKeys.URL_APP_MAIN + 'init/' + this.selectedIdCard + '/1'; //; 'http://192.168.0.26:4200/init/1/1';
    window.location.href = this.configKeys.URL_APP_MAIN + 'showCampaign/' + this.idCamp + '/1';

  }


  loadJQuery() {

    // console.log('Cargando JQUERY');

    $('.custom-select1').each(function () {
      var classes = $(this).attr('class'),
        id = $(this).attr('id'),
        name = $(this).attr('name');
      var template = '<div class="' + classes + '">';
      template += '<span class="custom-select1-trigger">' + $(this).attr('placeholder') + '</span>';
      template += '<div class="custom-options">';
      $(this).find('option').each(function () {
        template += '<span class="custom-option ' + $(this).attr('class') + '" data-value="' + $(this).attr('value') + '">' + $(this).html() + '</span>';
      });
      template += '</div></div>';

      $(this).wrap('<div class="custom-select1-wrapper"></div>');
      $(this).hide();
      $(this).after(template);
    });

    $('.custom-option:first-of-type').hover(function () {
      $(this).parents('.custom-options').addClass('option-hover');
    }, function () {
      $(this).parents('.custom-options').removeClass('option-hover');
    });

    $('.custom-select1-trigger').on('click', function () {
      $('html').one('click', function () {
        $('.custom-select1').removeClass('opened');
      });
      $(this).parents('.custom-select1').toggleClass('opened');
      event.stopPropagation();
    });

    $('.custom-option').on('click', function () {
      $(this).parents('.custom-select1-wrapper').find('select').val($(this).data('value'));
      $(this).parents('.custom-options').find('.custom-option').removeClass('selection');
      $(this).addClass('selection');
      $(this).parents('.custom-select1').removeClass('opened');
      $(this).parents('.custom-select1').find('.custom-select1-trigger').text($(this).text());
    });


  }


  //------ FOR HEADERS---------

  goToWebSite() {

    var url = this.paramBCWebSiteURL;

    if (2 === this.paramBCWebSiteURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }

  /*goToReqCard() {

    var url = this.paramReqCardURL[this.selectedIdCard-1];

    var wtarget =  this.paramReqCardURLTarget[this.selectedIdCard-1];

    if (2 === wtarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }*/


  public scrollRight(): void {
    console.log('Scroll right funct');
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + 150), behavior: 'smooth' });
  }

  public scrollLeft(): void {
    console.log('Scroll left funct');
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - 150), behavior: 'smooth' });
  }

  goToLink(url: string, target: number, promoName: string){

    console.log('goToLink url: ' + url);

    //--------------Call Google Analytics Event
    // this.googleAnalyticsService.eventEmitter('Promociones', 'Visitas Informativas',  'Informativa: Bancoppel - ' + promoName, 1);
    this.googleAnalyticsService.eventEmitter('Promociones', this.campaign.nombre,  'Informativa (' + this.campaign.nombre + '): Bancoppel - ' + promoName, 1);
    //--------------Call Google Analytics 4 Event
    this.eventGA4PushInteractions('bancoppel_promociones', this.campaign.nombre, 'Informativa (' + this.campaign.nombre + '): Bancoppel - ' + promoName);


    if(target===2)
      window.open(url, "_blank");
    else
      window.location.href=  url;
  }

  showPromoDetail(offerId: number){

    this.filterOfferService.setSelectedOffer(offerId)

  }

  eventGA4PushInteractions(event: string, card_campaign_sendingmean: string, labelValue: string) {

    // console.log('Registering event in GA4: ' + event);

    if (event === 'bancoppel_promociones') {
      (<any>window).dataLayer.push({
        event: event,
        card_campaign: card_campaign_sendingmean,
        promo_name: labelValue
      });
    } else if (event === 'bancoppel_banners') {
      (<any>window).dataLayer.push({
        event: event,
        card_campaign_banners: card_campaign_sendingmean,
        banner_name: labelValue
      });
    } else if (event === 'social_share') {
      (<any>window).dataLayer.push({
        event: event,
        sending_mean: card_campaign_sendingmean,
        promo_name_ss: labelValue
      });
    }
  }

  private parseFecha(fechaStr: string): Date | null {
    // Definir arrays para los nombres de los meses y días
    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    // Dividir la cadena en sus partes
    const partes = fechaStr.split(" de ");

    if (partes.length === 3) {
      const dia = parseInt(partes[0], 10);
      const mes = meses.indexOf(partes[1]);
      const año = parseInt(partes[2], 10);

      // Verificar si los valores son válidos
      if (!isNaN(dia) && mes >= 0 && !isNaN(año)) {
        const fecha = new Date(año, mes, dia, 23, 59, 59, 999);
        if (!isNaN(fecha.getTime())) {
          return fecha;
        }
      }
    }

    // Si no se pudo parsear la fecha, retornar null
    return null;
  }

}
